import React from 'react';
import { hasPermission } from 'services/permission'

interface IActionAnchor
	extends React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement> {
		actionCode?: string;
		label?:string;
	}

interface IMoreItem {
	title:string;
}

export default class extends React.Component<IActionAnchor> {

	static moreItem:React.FC<IMoreItem> = props => {
		return <li>{props.title}</li>
	}

	renderButton = () => {
		const { actionCode, label, ...restProps } = this.props
		if(!hasPermission(actionCode)) return <React.Fragment/>
		if(label==="更多") {
			return  <li className="app-select-Mult">
						<span className="app-select-Mult-span">{label}</span>
						<ul className="app-select-Mult-ul">
							{this.props.children}
						</ul>
					</li>
		}
		return <li className="app-select-Mult">
					<span className="app-select-Mult-span" {...restProps}>
						{this.props.label || ''}
					</span>
				</li>
	}

	render() {
		return this.renderButton()
	}
}


// WEBPACK FOOTER //
// ./src/components/AppAction/AppTableAction.tsx